function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconYenEnFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.458 3.164a.984.984 0 011.384.31L16.1 15.122l7.258-11.648a.983.983 0 011.384-.31c.464.308.597.943.3 1.42L17.929 16h3.57c.556 0 1 .464 1 1.029s-.444 1.028-1 1.028H17.1v2.586h4.4c.555 0 1 .463 1 1.029 0 .565-.445 1.028-1 1.028h-4.4v5.472c0 .565-.445 1.028-1 1.028-.555 0-1-.463-1-1.028V22.7h-4.4c-.555 0-1-.463-1-1.028 0-.566.445-1.03 1-1.03h4.4v-2.585h-4.4c-.555 0-1-.463-1-1.028S10.145 16 10.7 16h3.571L7.158 4.584a1.046 1.046 0 01.3-1.42z",
    fill: props.color
  }));
}

export default SvgIconYenEnFilled;